import { Span, styled } from 'sp-ui';

const Strong = styled(Span)(
    ({ theme }) => `
        font-weight: ${theme.fontWeights.medium};
    `
);

export default Strong;
